import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import InputAdornment from '@material-ui/core/InputAdornment';

import AccountCircle from '@material-ui/icons/AccountCircle';

import { UserRoleType } from '../../../models/User';

import cssStyles from '../resetPassword.module.css';
import { withStyles, Theme, createStyles, InputLabel, Select, OutlinedInput } from '@material-ui/core';

interface ResetPasswordProps {
  companyId: number;
  companies: { id: number, name: string }[];
  companyType: UserRoleType.FORWARDER | UserRoleType.GHA;
  firstName: string;
  lastName: string;
  classes: any;
  showSuccessMessage: boolean;
  onSubmit: (e: any) => void;
  sendManualRequest: (e: any) => void;
  onFieldChange: (event: any, value?: any) => void;
};

const styles = (theme: Theme) =>
  createStyles({
    companyId: {
      width: '100%',
    }, 
    namesField: {
      flex: '2 150px',
    },
     submit: {
      marginTop: 4,
      flex: '1 150px',
    },
     companyName: {
      width: 'clamp(100%, 60vw, 600px)',
      '& > div':{
        fontSize: '14px',
      }
    },
     companyTypeRadio: {
      height: 40,
      '& span':{
        fontSize: '15px',
      }
    }
  });

const ManualResetForm = (props: ResetPasswordProps) => {
  return (
    <div className={cssStyles.manualResetContainer}>
      <div className={cssStyles.manualResetFormContainer}>
        <div>
          <FormControl>
            <FormLabel className={ cssStyles.text }>What kind of company do you work for</FormLabel>
            <RadioGroup
              name="companyType"
              style={{width: 300}}
              value={props.companyType}
              onChange={props.onFieldChange}>
              <FormControlLabel value="gha" className={props.classes.companyTypeRadio} control={<Radio color="primary" />}
                label="GHA" />
              <FormControlLabel value="fwd" className={props.classes.companyTypeRadio} control={<Radio color="primary" />}
                label="Forwarder" />
            </RadioGroup>
          </FormControl>
        </div>
        <br/>
        <div>
          <FormControl>
            <Select
              name="manualCompanyId"
              value={props.companyId}
              onChange={props.onFieldChange}
              className={ props.classes.companyName }
              placeholder="Company name"

            >
              {props.companies.map(company => {
                return (<option value={company.id} key={company.id}>{company.name}</option>);
              })}

            </Select>
          </FormControl>
        </div>
        <br/>
        <form onSubmit={props.sendManualRequest} >
          <div className={cssStyles.namesContainer}>
            <TextField
              name='manualFirstName'
              label=""
              required
              className={`${props.classes.firstName} ${props.classes.namesField} ${cssStyles.textField}`}
              value={props.firstName}
              onChange={props.onFieldChange}
              InputLabelProps={{ 
                shrink: true,
                className: cssStyles.loginLabel
              }}
              InputProps={{ 
                classes:{ input: cssStyles.loginInput },
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle color="primary" className={ cssStyles.materialIcon }/>
                  </InputAdornment>
                ),
              }}
              placeholder="Enter your first name"   
            />
            <TextField
              name='manualLastName'
              label=""
              required
              className={`${props.classes.namesField} ${cssStyles.textField}`}
              value={props.lastName}
              onChange={props.onFieldChange}
              InputLabelProps={{ 
                shrink: true,
                className: cssStyles.loginLabel
              }}
              InputProps={{ 
                classes:{ input: cssStyles.loginInput },
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle color="primary" className={ cssStyles.materialIcon }/>
                  </InputAdornment>
                ),
              }} 
              placeholder=" Enter your last name"  
            />
            <Button type="submit" className={`${props.classes.namesField} ${props.classes.submit}`} color="primary" variant="contained">Submit</Button>
          </div>
          <br/>
            <p style={{display: props.showSuccessMessage? 'inline': 'none'}}>A request to reset your password has been sent. Please contact your system administrator(s) 
              to retrieve a default password which you must change immediately after your next login.</p>
        </form>
      </div>
    </div>
  );
};

export default withStyles(styles)(ManualResetForm);